import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteSportMapping } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "@/tanstackQuery/queries/sportsNew";

export const useDeleteSportMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ sportId, id }: { sportId: number; id: number }) =>
      deleteSportMapping(sportId, id),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SportsNewQueryKeys.SportMappings, variables.sportId],
      });
    },
  });
};
